export const API_URL = "https://staging-api.hifigamingsociety.org";
// export const API_URL = "https://146.19.207.168:44344";
//export const API_URL = "https://localhost:44344";
export const MINIMUM_PLAY_FOR_REWARD = 10